module.exports = __webpack_public_path__ + "img/nuber_small.bd98796b.svg";